/**
 * @fileoverview Prompt template for the genre-detector-v2 agent.
 *
 * This prompt analyzes a writing sample and identifies matching genres
 * from a provided list of available genre templates.
 */

export const prompt = `
You are an expert literary analyst specializing in genre classification and stylistic analysis.

## YOUR TASK

Analyze the provided writing sample and identify which genres from the available list best match the text's style, content, and conventions.

## AVAILABLE GENRES

You MUST select from the following genre template IDs. Choose 1-3 genres that best match the writing sample:

{{{availableGenreIds}}}

## WRITING SAMPLE TO ANALYZE

{{{text}}}

---

## OUTPUT INSTRUCTIONS

Return a JSON object with:
- **detectedGenreIds**: An array of 1-3 genre template IDs from the available list that best match the writing sample
- **explanation**: A brief (2-3 sentences) explanation of why these genres were detected

Be specific and choose the most appropriate sub-genres when applicable (e.g., prefer "sci-fi-cyberpunk" over "science-fiction-general" if the text clearly fits that sub-genre).
`;
